import names from '@/modules/recording/routers/names'
import {ACCOUNTS_INSTANCE, ORGANIZATION_INSTANCE, RECORDING_INSTANCE} from "@/helper/consts";
import AdminEventMenu from "@/modules/recording/page/eventAdmin/AdminEventMenu.vue"
import EventsDetail from "@/modules/recording/page/eventAdmin/EventsDetail.vue";
import TokenDetail from "@/modules/recording/page/eventAdmin/TokenDetail.vue";

export default ([
    {
        path: '/local',
        name: names.ADMINEVENTS._BASE,
        component: AdminEventMenu,
        meta: {
            breadcrumb: 'Администрирование',
            requiredAuth: true,
            instances: [
                RECORDING_INSTANCE,
                ACCOUNTS_INSTANCE
            ],
        },

                children:[
                    {
                        path: ':event',
                        name: names.ADMINEVENTS.DETAIL,
                        component: EventsDetail,
                        meta: {
                            breadcrumb: 'Подробнее',
                            requiredAuth: true,
                            instances: [
                                RECORDING_INSTANCE,
                            ],
                        },
                        children:[
                            {
                                path: ':token',
                                name: names.ADMINEVENTS.TOKEN,
                                component: TokenDetail,
                                meta: {
                                    breadcrumb: 'Подробнее',
                                    requiredAuth: true,
                                    instances: [
                                        RECORDING_INSTANCE,
                                    ],
                                },
                            }
                        ]
                    }
                ]
    }
])
